import { styled } from '@mui/system';

export const Wrapper = styled('div')`
  .MuiFormControl-root {
    .MuiFormLabel-root {
      top: -2px;
    }
  }

  .MuiInputBase-root {
    height: 38px;

    .MuiSvgIcon-root {
      display: block;
      width: 20px;
      height: 20px;
      top: 9px;
    }
  }
`;
